import React, { useState } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Grid, TextField, Typography, List, ListItem, Link, } from '@mui/material';
const classes = {
    grid: {
        padding: '8px',
        textAlign: 'center',
    },
    description: {
        color: 'rgba(0, 0, 0, 0.6)',
        textAlign: 'center',
        paddingBottom: '30px',
        marginTop: '-20px',
    },
};
const isNumber = (input) => /^-?\d+(\.\d+)?$/.test(input);
export const CoordinateWidget = ({ spatialParameters, setSpatialParameter, }) => {
    const [interactiveMode, interactiveModeOn] = useState(false);
    const handleChange = (event) => {
        interactiveModeOn(event.target.checked);
    };
    // Add some timeout before setting state in the inputs
    const changeParameter = (event, parameters = spatialParameters) => {
        if (event.target.id === 'bbox') {
            const newParameters = {
                minlat: '',
                maxlat: '',
                minlon: '',
                maxlon: '',
            };
            [
                newParameters.minlat = '',
                newParameters.minlon = '',
                newParameters.maxlat = '',
                newParameters.maxlon = '',
            ] = event.target.value.split(',');
            setSpatialParameter(newParameters);
        }
        else {
            setSpatialParameter(Object.assign(Object.assign({}, parameters), { [event.target.id]: event.target.value }));
        }
    };
    const fieldErrors = {};
    Object.keys(spatialParameters).forEach((key) => {
        if (!spatialParameters[key]) {
            fieldErrors[key] = 'This is a required field';
            return;
        }
        if (!isNumber(spatialParameters[key])) {
            fieldErrors[key] = 'Must be a number';
            return;
        }
        if (key === 'minlat' || key === 'maxlat') {
            if (Math.abs(Number(spatialParameters[key])) > 90) {
                fieldErrors[key] = 'Value has to be between -90 and 90';
            }
        }
        if (key === 'minlon' || key === 'maxlon') {
            if (Math.abs(Number(spatialParameters[key])) > 180) {
                fieldErrors[key] = 'Value has to be between -180 and 180';
            }
        }
    });
    return (React.createElement(Grid, { container: true, sx: { justifyContent: 'space-around' }, item: true, xs: 12 },
        React.createElement(Grid, { component: 'label', container: true, alignItems: 'center', xs: 12, sx: classes.grid },
            React.createElement(FormControlLabel, { style: { padding: '5px 0' }, control: React.createElement(Switch, { color: 'primary', checked: interactiveMode, onChange: handleChange, name: 'interactiveMode' }), label: 'Interactive' })),
        interactiveMode ? (React.createElement(React.Fragment, null,
            React.createElement(Grid, { item: true, xs: 4 }),
            React.createElement(Grid, { item: true, xs: 5 },
                React.createElement(Typography, { sx: classes.description },
                    React.createElement(List, { dense: true },
                        React.createElement(ListItem, null,
                            "- Go to\u00A0",
                            React.createElement(Link, { href: 'http://bboxfinder.com/', target: '_blank', rel: 'noopener' }, "http://bboxfinder.com/"),
                            "."),
                        React.createElement(ListItem, null, "- Select \"Lat / Lng\" on the bottom right."),
                        React.createElement(ListItem, null, "- Draw a rectangle."),
                        React.createElement(ListItem, null, "- Copy paste the coordinates behind \"Box\" on the bottom left below.")))),
            React.createElement(Grid, { item: true, xs: 3 }),
            React.createElement(Grid, { item: true, xs: 12, sx: classes.grid },
                React.createElement(TextField, { id: 'bbox', label: 'Bounding box', variant: 'outlined', value: `${spatialParameters.minlat},${spatialParameters.minlon},${spatialParameters.maxlat},${spatialParameters.maxlon}`, error: !!fieldErrors.minlat ||
                        !!fieldErrors.minlon ||
                        !!fieldErrors.maxlat ||
                        !!fieldErrors.maxlon, helperText: (!!fieldErrors.minlat ||
                        !!fieldErrors.minlon ||
                        !!fieldErrors.maxlat ||
                        !!fieldErrors.maxlon) &&
                        'Wrongly formatted bbox string.', onChange: changeParameter, required: true })))) : (React.createElement(React.Fragment, null,
            React.createElement(Grid, { item: true, xs: 6, sx: classes.grid },
                React.createElement(TextField, { id: 'minlat', label: 'Min. Latitude', variant: 'outlined', value: spatialParameters.minlat, error: !!fieldErrors.minlat, helperText: fieldErrors.minlat, onChange: changeParameter, required: true })),
            React.createElement(Grid, { item: true, xs: 6, sx: classes.grid },
                React.createElement(TextField, { id: 'maxlat', label: 'Max. Latitude', variant: 'outlined', value: spatialParameters.maxlat, error: !!fieldErrors.maxlat, helperText: fieldErrors.maxlat, onChange: changeParameter, required: true })),
            React.createElement(Grid, { item: true, xs: 6, sx: classes.grid },
                React.createElement(TextField, { id: 'minlon', label: 'Min. Longitude', variant: 'outlined', value: spatialParameters.minlon, error: !!fieldErrors.minlon, helperText: fieldErrors.minlon, onChange: changeParameter, required: true })),
            React.createElement(Grid, { item: true, xs: 6, sx: classes.grid },
                React.createElement(TextField, { id: 'maxlon', label: 'Max. Longitude', variant: 'outlined', value: spatialParameters.maxlon, error: !!fieldErrors.maxlon, helperText: fieldErrors.maxlon, onChange: changeParameter, required: true }))))));
};
